import { Component, OnInit } from "@angular/core";
import { NotificationsService } from "./notifications.service";
import { Router } from "@angular/router";
import * as moment from "moment";

@Component({
  selector: "notifications-component",
  template: require('./notifications.component.html'),
  styles: [
    require('./notifications.component.scss'),
    require('../bindings/bindings.component.scss')
  ]
})
export class NotificationsComponent implements OnInit {
  notifications: any[];
  reverse: boolean;
  predicate: string = "created_at";
  projects: any[] = [{ name: "Projects" }];
  nationalities: any[] = [{ name: "Nationalities" }];
  programs: any[] = [{ name: "Programs" }];
  employers: any[] = [{ name: "Employers" }];
  countries: any[] = [{ name: "Countries" }];
  projectFilter: string;
  nationalityFilter: string;
  employerFilter: string;
  programFilter: string;
  itemsPerPageValues: number[];
  nextDisabled: Boolean = false;
  itemsPerPage: number = 10;
  page = 0;
  getFieldOrderBy: Function;

  constructor(private service: NotificationsService, private router: Router) {
    // Do stuff
  }

  ngOnInit() {
    this.getNationalities();
    this.getCountries();
    this.getNotifications();
    this.getProjects();
    this.getEmployers();
    this.getPrograms();
    this.sortBy("it.created_at", "created_at");

    this.itemsPerPageValues = this.service.getItemsPerPageValues();
    //this.itemsPerPage = this.service.getItemsPerPage();
  }

  getNotifications() {
    return this.service
      .getNotifications({ page: this.page, limit: this.itemsPerPage })
      .subscribe((res) => {
        this.notifications = res;
        if (res.length < this.itemsPerPage) {
          this.nextDisabled = true;
        } else {
          this.nextDisabled = false;
        }
      });
  }

  getProjects() {
    this.service.getProjects().subscribe((projects) => {
      this.projects = this.projects.concat(projects);
    });
  }

  getNationalities() {
    let nations = this.service.getCountries();
    this.nationalities = this.nationalities.concat(nations);
  }

  getCountries() {
    let nations = this.service.getCountries();
    this.countries = this.countries.concat(nations);
  }

  getEmployers() {
    this.service.getEmployers().subscribe((employers) => {
      this.employers = this.employers.concat(employers);
    });
  }

  getPrograms() {
    this.service.getPrograms().subscribe((programs) => {
      this.programs = this.programs.concat(programs);
    });
  }

  sortBy(getField: string, fieldName: string) {
    this.reverse = !this.reverse;
    this.reverse = this.predicate === fieldName ? this.reverse : false;
    this.predicate = fieldName;
    this.getFieldOrderBy = new Function(
      "it",
      `return (${getField} || '').toString().toLowerCase();`
    );
  }

  formatDate(date: any) {
    return moment(date).format("DD/MM/YYYY hh:mm A");
  }

  getCountryNames(ids: string[]): string[] {
    return this.service.getCountryNames(ids);
  }

  getLanguageNames(ids: string): string[] {
    return this.service.getLanguageNames([ids]);
  }

  getProgramNames(programs) {
    if (programs && programs.length) {
      const progs = programs.map((program) => {
        const result = this.programs.find((prog) => prog.id == program);
        if (result) {
          return result.name;
        }
      });

      return progs.join();
    } else {
      return "<any>";
    }
  }

  pageChange(value) {
    this.page = this.page + value;
    this.getNotifications();
  }

  onChangeItemsPerPage(value) {
    this.itemsPerPage = value;
    this.page = 0;
    this.getNotifications();
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/notifications/notifications.component.ts